import React from 'react';

import * as Styled from './placeholder.style';

export type PlaceholderProps = {
  dayWidth: number;
  dayIndex: number;
  durationDays: number;
};

export const Placeholder: React.FC<PlaceholderProps> = ({
  dayWidth,
  dayIndex,
  durationDays,
}) => {
  const width = durationDays * dayWidth;
  const snappedX = dayIndex * dayWidth;
  const left = snappedX - width / 2;

  return (
    <Styled.Container
      $width={durationDays * dayWidth}
      style={{ left: `${left}px` }}
    />
  );
};
